import React, { useContext } from "react";
import PostGallery from "../../components/utilities/PostGallery";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { Box, Container, Grid, Typography } from "@mui/material";
import { BCPSquarePlus } from "../../components/icons/bcp/BCPIcons";

export default function PageList() {
  const authContext = useContext(AuthContext);
  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container sx={{ gap: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              p: 2,
            }}
          >
            <Typography variant="h3">My Pages</Typography>
          </Grid>

          <Grid item xs={12} sx={{ p: 2 }}>
            <PostGallery
              doSearch
              doPaging
              editMode
              pageType="page"
              status="all"
              searchLabel="Search My Pages"
              authorId={authContext?.authState?.identity?.userId}
              actionButton={[
                {
                  props: {
                    variant: "contained",
                    color: "primary",
                    href: "/cms/post",
                    startIcon: <BCPSquarePlus />,
                  },
                  label: "New Page",
                },
              ]}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
